/* eslint-disable func-names */
import * as yup from 'yup';

declare module 'yup' {
  // @ts-ignore
  interface StringSchema extends yup.StringSchema {
    isPersianMobile(): StringSchema;
    requiredNoSpace(): StringSchema;
  }
}

yup.setLocale({
  mixed: {
    required: 'لطفاً این قسمت را خالی نگذارید.',
    notType: 'لطفاً این قسمت را خالی نگذارید.',
  },
  string: {
    email: 'باید ایمیل باشد.',
  },
  number: {
    positive: 'باید بیشتر از صفر باشد.',
    negative: 'باید کمتر از صفر باشد.',
  },
});

yup.addMethod(yup.string, 'isPersianMobile', function (message) {
  return this.test('test-name', message, function (value) {
    const { path, createError } = this;
    const regex = /^(0|0098|\+98)9\d{9}$/;
    return (
      regex.test(value || '') ||
      createError({
        path,
        message: message || 'شماره موبایل را به صورت صحیح وارد کنید!',
      })
    );
  });
});

yup.addMethod(yup.string, 'requiredNoSpace', function (message) {
  return this.test('test-name', message, function (value) {
    const { path, createError } = this;
    return (
      String(value).trim().length > 0 ||
      createError({
        path,
        message: message || 'وارد کردن فیلد الزامی می\u200Cباشد!',
      })
    );
  });
});

export default yup;
